angular.module('rjmNg.directives').directive "persistentViews", [
  () ->
    restrict: "E"
    templateUrl: "directive.persistentViews.html"
    replace: false
    controllerAs: "vm" # view model, calling this view would have been too confusing
    bindToController: true
    scope: {}
    controller: [
      '$routeParams'
      'persistentViewsService'
      'notification'
      'app'
      'appRoute'
      '$q'
      '$modal'
      '$rootScope'
      (
        $routeParams
        persistentViewsService
        notification
        app
        appRoute
        $q
        $modal
        $rootScope
      ) ->

        vm = @
        vm.createViewRoute = appRoute('/settings/persistent-views/view')
        vm.displayDependencyResolver = false
        vm.loadingList = false
        vm.viewList = []
        vm.viewIcon = 'rj-icon rj-icon--eye'

        vm.confirmDelete = () -> null
        vm.cancelDelete = () -> _dontDropDependencies()

        _configViewLists = (viewsData) ->
          vm.viewList = viewsData.map((v) ->
                              v.orderDate = new Date(v.created_at)
                              v
                            )

        _deletionError = (error) ->
          vm.loadingList = false
          notification.error("error", "Error deleting view", "persistent-views", "", 5)

        _deletionSuccess = (view) ->
          vm.loadingList = false
          vm.viewList = _.reject(vm.viewList, ({id}) ->
            id is view.id
          )
          notification.success("deleted", "Deleted Successfully!", "persistent-views", "", 5)

        _handleDeleteRequest = (result) ->
          vm.dependencies = result
          vm.displayDependencyResolver = true

        _deleteViewWithSchema = (view) ->
          persistentViewsService.attemptDropViewTable(view).then((result) ->
            _handleDeleteRequest(result)
          , _deletionError
          )

        vm.showDeleteModal = (view) ->
          persistentViewsService.showDeleteModal(view, () -> vm.delete(view))

        vm.delete = (view) ->
          vm.loadingList = true
          vm.confirmDelete = () ->
            vm.displayDependencyResolver = false
            _dropDependencies(view)

          if view.status is 'active'
            persistentViewsService.attachSchema(view).then((viewSchema) ->
              _deleteViewWithSchema(viewSchema)
            , _deletionError
            )
          else if view.status is 'pending' # no schema or dependnecies, just delete data-warehouse-service view
            # first see if there actually is a schema...
            persistentViewsService.attachSchema(view).then((viewSchema) ->
              # there was a schema now continue as usual
              _deleteViewWithSchema(viewSchema)
            , (error) ->
              if error is "Couldn't find #{view.name}"
                # this view does not have a schema delete the view
                persistentViewsService.deleteView(view).then((result) ->
                  _deletionSuccess(view)
                , _deletionError
                )
              else
                # something else went wrong
                _deletionError(error)
            )

        _dropDependencies = (view) ->
          vm.loadingList = true
          persistentViewsService.forceDropViewTable(view).then((result) ->
            _deletionSuccess(view)
          , _deletionError
          )

        _dontDropDependencies = ->
          vm.displayDependencyResolver = false
          vm.dependencies = null
          vm.loadingList = false

        vm.loadPersistentViews = ->
          vm.loadingList = true
          persistentViewsService.get().then((result) ->
            _configViewLists(result)
            vm.loadingList = false
          , (error) ->
            vm.loadingList = false
            notification.error("error", "Error loading Data Warehouse Views", "persistent-views", "", 5)
          )

        vm.init = ->
          vm.loadPersistentViews()
          if(app.canEditPersistentViews())
            vm.viewIcon = 'rj-icon rj-icon--edit'

        vm
    ]
    link: (scope, elem, attrs) ->
      scope.vm.init()
]
